import requestDefault from '@/shared/utils/request';
import { RequestDecoratorEnum } from '@/shared/utils/request/enum';
import requestDecorator from '@/shared/utils/request/requestDecorator';
import {
  GetRightPayParamsType,
  GetRightContractType,
  RightsSummaryGet,
  RightSummaryType,
  CallbackType,
  GetRightSummaryType,
  RightCheckResultType,
  BuyEquityResponseType,
  CheckSuperCardTabResponseType,
  SuperCardSummaryBackType,
  CheckSuperCardMyPageShow,
  getCreditBuyEquityParamType,
  GetSuperMemberReqType,
  GetGalileoExpResult,
  GetGalileoExpResultResponseType,
  CheckDualChannelLightParamsType,
  CheckDualChannelLightResponseType,
} from './types';

/** 及未权益支付接口 */
export const getRightAliPayUrl = (
  params: GetRightPayParamsType,
): Promise<{payRouteUrl:string}> => requestDefault.postGate(
  'f.marketing.rights.order.channel.payUrl',
  {
    ...params, extendDataJson: JSON.stringify(params.extendDataJson),
  },
);

/** 权益合同获取接口 */
export const getRightContractUrl = (
  params: GetRightContractType,
): Promise<{contractUrl:string}> => requestDefault.postGate(
  'f.marketing.rights.contract.detail',
  {
    ...params,
  },
);

/** f.marketing.rights.package.queryChannelBSummary(查询权益概要,包含自营&联营) */
export const getRightsSummary = (
  params: RightsSummaryGet,
): Promise<RightSummaryType> => {
  const actionName = 'f.marketing.rights.package.queryChannelBSummary';
  const fetchData = async ():
  Promise<RightSummaryType> => requestDefault.postGate(
    actionName,
    {
      ...params,
    },
  );

  return requestDecorator(
    RequestDecoratorEnum.REQUEST_PARAMS,
    fetchData,
    params,
    actionName,
  );
};


/** f.marketing.rights.package.showRuleCheck(判断自营B用户是否符合规则)
 * yapi地址：https://yapi.hellobike.cn/project/7020/interface/api/325237
*/
export const getCheckResult = (
  params: GetRightSummaryType,
): Promise<RightCheckResultType> => requestDefault.postGate(
  'f.marketing.rights.package.showRuleCheck',
  { ...params },
);

/** f.loan.equity.isCallback(自营提现是否权益召回) */
export const isCallback = (): Promise<CallbackType> => requestDefault.postGate(
  'f.loan.equity.isCallback',
  {},
  {
    showLoading: undefined,
  },
);

/** f.marketing.rights.package.superCardCreditSummary(获取授信协议页是否展示权益超级会员栏)
 * 需求 https://metis2.hellobike.cn/browse/SKHYQY-1817 超会plus需求迁移到营销服务
 * https://yapi.hellobike.cn/project/3415/interface/api/331869
*/
export const getCreditBuyEquity = (params: getCreditBuyEquityParamType):
Promise<BuyEquityResponseType> => requestDefault.postGate(
  'f.marketing.rights.package.superCardCreditSummary',
  { ...params },
  { showLoading: undefined },
);


/** f.marketing.rights.package.checkSuperCardTabShow(超级会员卡tab展示校验接口)
 * https://yapi.hellobike.cn/project/7020/interface/api/332953
*/
export const checkSuperCardTabShow = ():
Promise<CheckSuperCardTabResponseType> => requestDefault.postGate(
  'f.marketing.rights.package.checkSuperCardTabShow',
  {},
  // 不展示报错
  { showErrMsg: undefined },
);

/** f.marketing.rights.package.superCardSummary(查询超级会员权益包概览信息)
 * https://yapi.hellobike.cn/project/7020/interface/api/357385
*/
export const getSuperMemberCardSummary = (
  params: GetSuperMemberReqType,
): Promise<SuperCardSummaryBackType> => requestDefault.postGate(
  'f.marketing.rights.package.superCardSummary',
  {
    ...params,
  },
);

/** f.marketing.rights.package.checkSuperCardMyPageShow(超级会员卡我的页面是否展示)
 * https://yapi.hellobike.cn/project/7020/interface/api/357404
*/
export const checkSuperCardMyPageShow = ():
Promise<CheckSuperCardMyPageShow> => requestDefault.postGate(
  'f.marketing.rights.package.checkSuperCardMyPageShow',
);


/** f.marketing.rights.package.queryGalileoExpResult(查询伽利略实验结果)
 * https://yapi.hellobike.cn/project/7020/interface/api/392269
*/
export const getGalileoExpResult = (
  params: GetGalileoExpResult,
): Promise<GetGalileoExpResultResponseType> => requestDefault.postGate(
  'f.marketing.rights.package.queryGalileoExpResult',
  {
    ...params,
  },
);

/** f.loan.check.rightLight(判断是否满足轻资产承接场景)
 * 判断是否满足24+权益单通道切换普通通道需使用轻资产承接场景
 * 需求方案：https://hellobike.yuque.com/gpxxgb/oyyz8n/bstne67wr8wgd5d2
 * yapi地址：https://yapi.hellobike.cn/project/3415/interface/api/403113
*/
export const checkDualChannelLight36 = (
  params: CheckDualChannelLightParamsType,
): Promise<CheckDualChannelLightResponseType> => requestDefault.postGate(
  'f.loan.check.rightLight',
  { ...params },
  {
    showErrMsg: undefined,
  },
);

/**
 * 查询是否存在授权项 用于设置页面展示
 * https://yapi.hellobike.cn/project/7020/interface/api/416997
*/
export const checkAuthManagement = ():
Promise<boolean> => requestDefault.postGate(
  'f.marketing.rights.member.queryAuth',
  {},
);
